import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SessionSelectors } from '@next/core-lib/session';
import { IgnoreRelationshipHeaderPatterns } from '@next/core-lib/user';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { AppState } from './shared/models';

@Injectable()
export class LocationInterceptor implements HttpInterceptor {
  private readonly store = inject<Store<AppState>>(Store);
  private readonly ignoreRelationshipHeaderPatterns = inject(IgnoreRelationshipHeaderPatterns) as string[][];

  static selectedLocationIdHeader = 'Next-LocationId';

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const matches = this.ignoreRelationshipHeaderPatterns.some(
      (ignoreRelationshipHeaderPattern) => ignoreRelationshipHeaderPattern.some((regex) => new RegExp(regex).test(req.url)),
    );

    return matches
      ? next.handle(req)
      : this.store.pipe(
          select(SessionSelectors.selectSessionLocationId),
          take(1),
          switchMap((locationId) =>
            locationId
              ? next.handle(
                  req.clone({
                    setHeaders: {
                      [LocationInterceptor.selectedLocationIdHeader]: locationId.toString(),
                    },
                  }),
                )
              : next.handle(req),
          ),
        );
  }
}
